import {PublicPageStyle} from "../../constants/styles";
import PublicTemplate from "../publics/PublicTemplate";
import styled from "styled-components";
import {DevicePoint} from "../atoms/postion/DevicePoint";
import {useEffect, useRef, useState} from "react";
import {Button, message, Select} from "antd";
import axios from "axios";

const PositionSettingPage = () => {
    const [imageSize, setImageSize] = useState<{width: number; height: number}>({
        width: 0,
        height: 0,
    });
    const [formattedPosition, setFormattedPosition] = useState<{left: number; top: number}>({
        left: 0,
        top: 0,
    });
    const [stores, setStores] = useState<Array<{no: number; name: string}>>([]);
    const [selectedStore, setSelectedStore] = useState<number | null>(null);

    const [acList, setAcList] = useState<Array<{no: number; name: string; positionX: number; positionY: number}>>([]);
    const [selectedAc, setSelectedAc] = useState<number | null>(null);

    const imageRef = useRef(null);

    const handleOnLoad = () => {
        if (imageRef.current)
            setImageSize({
                width: imageRef.current.getBoundingClientRect().width,
                height: imageRef.current.getBoundingClientRect().height,
            });
    };

    const handleSave = () => {
        setAcPosition();
    };
    const getStores = async () => {
        const res = await axios.get(`${window.location.protocol}//lottesuper.porestn.com:9091/v1/stores`);
        if (res.data) setStores(res.data);
    };
    const getAc = async () => {
        const res = await axios.get(
            `${window.location.protocol}//lottesuper.porestn.com:9091/v1/airConditionings/${selectedStore}`,
        );
        if (res.data) setAcList(res.data);
    };

    const setAcPosition = async () => {
        const res = await axios.put(
            `${window.location.protocol}//lottesuper.porestn.com:9091/v1/airConditionings/${selectedAc}/position`,
            {
                positionX: formattedPosition.left,
                positionY: formattedPosition.top,
            },
        );
        if (res.status === 200) {
            message.success("성공");
            getAc();
        }
    };

    useEffect(() => {
        getStores();
    }, []);
    useEffect(() => {
        if (selectedStore) getAc();
    }, [selectedStore]);

    return (
        <PublicPageStyle>
            <PublicTemplate>
                <>
                    <ListContainer>
                        <Select
                            value={selectedStore}
                            onChange={(e) => setSelectedStore(e)}
                            options={stores.map((item) => ({
                                label: item.name + `(${item.no})`,
                                value: item.no,
                            }))}
                            className={"select"}
                            placeholder={"지점선택"}
                        />
                        <ul className={"list"}>
                            {acList.map((item, index) => (
                                <li
                                    key={index}
                                    className={`item ${item.no === selectedAc ? "selected" : ""}`}
                                    onClick={() => setSelectedAc(item.no)}
                                >
                                    {item.no} : {item.name} / x: {item.positionX} / y: {item.positionY}
                                </li>
                            ))}
                        </ul>
                    </ListContainer>
                    <Container>
                        <h3>[롯데슈퍼] 디바이스 위치설정</h3>
                        <p>
                            top: {formattedPosition.top} % // left: {formattedPosition.left} %
                        </p>
                        <div className={"image-container"}>
                            <ImageBase ref={imageRef}>
                                <Image
                                    src={require(`../../assets/img/maps/${selectedStore || 0}_map.png`)}
                                    onLoad={handleOnLoad}
                                />
                                <DevicePoint imageSize={imageSize} setFormattedPosition={setFormattedPosition} />
                            </ImageBase>
                        </div>
                        <Button onClick={handleSave}>저장!!</Button>
                    </Container>
                </>
            </PublicTemplate>
        </PublicPageStyle>
    );
};

export {PositionSettingPage};

const Container = styled.div`
    width: 50%;

    .image-container {
        width: 80%;
        margin: 50px auto;
    }
`;

const ImageBase = styled.div`
    position: relative;
`;

const Image = styled.img`
    width: 100%;
`;

const ListContainer = styled.ul`
    width: 40%;
    height: 100%;
    border: 1px solid red;
    box-sizing: border-box;
    padding: 50px;
    margin-right: 5%;
    overflow: auto;

    .select {
        width: 300px;
    }

    .list {
        width: 100%;
        list-style: none;
        margin-top: 24px;

        .item {
            padding: 12px;
        }

        .item:hover {
            background: #f1f1f1;
            cursor: pointer;
        }

        .selected {
            background: #dddddd;
        }
    }
`;
